export default __webpack_public_path__ + "static/20210508hashiri4-ff95cd4a3507da3fd643ebf2df371f19.jpg";